export enum UserRole {
    Admin = 'Admin',
    User = 'User',
    Moderator = 'Moderator',
    None = ''
}

function getUserRoleId(role: UserRole): number {
    switch (role) {
        case UserRole.Admin:
            return 3
        case UserRole.Moderator:
            return 2
        case UserRole.User:
            return 1
        case UserRole.None:
            return 0
    }
}

export function isAtLeastRole(role: UserRole): ((currentRole: UserRole) => boolean) {
    const roleId = getUserRoleId(role)
    return (currentRole: UserRole) => 
        getUserRoleId(currentRole) >= roleId
}

export enum AuthenticationStatus {
    LoggedOut = 0,
    LoggedIn = 1,
    Success = 2,
    Failed = 3
}

export enum SnackbarStatus {
    FAIL = 0,
    SUCCESS = 1
}